import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteRtvActions } from "store/ducks/settings/rtv";

export function* deleteRtvRequest(action: any) {
  try {
    const { id, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.delete,
      `/rtv/${id}`,
    );

    const { data } = responseBody;
    yield put(DeleteRtvActions.success(data));
    notify("success", "RTV deletado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteRtvActions.failure(errorMessage));
  }
}
